import { render, staticRenderFns } from "./DailyComparisonCard.vue?vue&type=template&id=2ada8fdc&scoped=true&"
import script from "./DailyComparisonCard.vue?vue&type=script&lang=js&"
export * from "./DailyComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./DailyComparisonCard.vue?vue&type=style&index=0&id=2ada8fdc&prod&scoped=true&lang=scss&"
import style1 from "./DailyComparisonCard.vue?vue&type=style&index=1&id=2ada8fdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada8fdc",
  null
  
)

export default component.exports